import config from '../../../../../../../../../../config'

import { SUBMIT_CHANGE_PASSWORD_FORM, CHANGE_PASSWORD_REQUEST } from './constants'

export function submitDataForm(contentId, values) {
    return {
        type: SUBMIT_CHANGE_PASSWORD_FORM,
        data: {
            contentId,
            values,
        },
    }
}

export function changePasswordRequest(sessionId, currentPassword, newPassword) {
    return {
        type: CHANGE_PASSWORD_REQUEST,
        payload: {
            ...config.api.userPasswordChange,
            formData: `old_password=${encodeURIComponent(currentPassword)}&new_password=${encodeURIComponent(
                newPassword
            )}`,
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                sid: sessionId,
                Accept: 'text/html',
            },
        },
    }
}
